export const apiURL =
  "https://script.google.com/macros/s/AKfycbySAuU8xgMCaSjspvs6Oec3uazcu_cXlNeV8ChjErKpeEEcYEWr6Z8z1x0uNUKzOTVs7g/exec";
